<template>
  <div
      draggable="true"
      @dragover="dragOverInner(data)"
      @dragleave.stop="dragLeaveInner(data)"
      @dragend.prevent="dragEndInner(data, $event)"
      :class="{ inlineBlock: true, wrapper: true}"
      >
    <div
        class="uk-label chip"
        v-bind:class="{ active: isActive, over:dragEntered, beforeExit: beforeExit, secondary:secondary }"
        v-bind:style="{backgroundColor: color ? color : null}"
        @click="clickEvent"
    >
            {{ deslug(data.name) }}
        <span
              v-if="isRemoveable"
              @mouseover="beforeExit=true"
              @mouseout="beforeExit=false"
              @click.stop="() => $emit('remove', data)"
              class="remove-btn">x
        </span>
    </div>
  </div>
</template>

<script>

  import deslug from '@/utils/deslug';

export default {
    name: "Chip",
    props:["data", "idx", 'secondary', "removeable", "color"],
    data: function(){
      return {
        isActive: false,
        dragEntered: false,
        isDrag: false,
        beforeExit: false,
        isRemoveable: this.removeable != null ? this.removeable : true,
      }
    },
    methods: {
    	deslug,
      dragOverInner: function() {
        this.dragEntered = true;
      },
      dragEndInner: function(data) {
        this.isActive = false;
        this.dragEntered = false;
        this.isDrag = false;
      },
      dragLeaveInner: function(data, event) {
        this.dragEntered = false;
      },
        clickEvent: function() {
    	    this.$emit('clickEvent', true)
    	    console.log('click')
        },
    },
  }

</script>

<style lang="less" scoped>
  @import "../../assets/less/palette.less";


 .inlineBlock {
    display: inline-block;
  }

  .wrapper {
    transition: all 333ms ease;
  }

  .chip {
      display: inline-block;
      background-color: @primary;
      margin: 5px;
      border-radius: 4px;
      padding: 5px 10px;
      transition: all 333ms ease;


    &:hover {
      cursor: pointer;
      background-color: @primary-3;
      box-shadow: 1px 1px 4px rgba(0,0,0,.25),
                  -1px -1px 4px rgba(0,0,0,.25),
                  1px -1px 4px rgba(0,0,0,.25),
                  -1px 1px 4px rgba(0,0,0,.25);
    }


    &.secondary {
       background-color:  @secondary;

      &:hover {
        background-color: @secondary-3;
      }

    }
  }


  .active {
    background-color: pink;
  }

  .over {
    background-color: @warning-2;
  }

  .left {
    padding-left: 25px;
  }

  .right {
    padding-right: 75px;
  }

  .remove-btn {
    padding: 0 3px;
    margin-left: 5px;
  }

  .remove-btn:hover {
    font-weight: bolder;
  }

  .beforeExit {
    background-color: @danger-3!important;
  }


</style>
